module.exports = __webpack_public_path__ + "img/health.9b648541.svg";